module.exports = __webpack_public_path__ + "static/about_us_1.851f42ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/about_us_1.jpg
// module id = 381
// module chunks = 29096074603545 162898551421021